// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-flow: row wrap;
}

h6 {
  text-align: left;
}

.error-small {
  font-size: 12px;
  white-space: pre;
}

.top-margin {
  margin-top: 30px;
}

.left-padding {
  margin-left: 15px;
  padding-top: 5px;
}

.left-margin {
  margin-left: 23px;
}

.margin-left-postal {
  margin-left: -5px;
}

.z-index {
  z-index: 9000;
}

.check-box-input-margin-left {
  margin-left: 8px;
}

.left-padding-displayGroups {
  padding-left: 40px;
  margin-bottom: 15px;
}

.label-width {
  width: 100px;
}

.left-margin-span {
  margin-left: -5px;
}

.form-control:disabled, .form-control[readonly] {
  background-color: lightgray !important;
  opacity: 1;
}

.grey-out {
  background-color: lightgray;
  opacity: 1;
}

.grey-out2 {
  background-color: lightgray;
  opacity: 1;
}

/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */
.mat-select-disabled, .mat-select-value {
  background-color: lightgray;
}

.align-select-button {
  margin-top: 25px;
  padding-bottom: 0px;
}

.displayGroupsMargin {
  margin-left: 15px;
}

.check-box-margin {
  margin-left: -6px;
  margin-bottom: 5px;
}

.margins {
  margin-left: -17px;
  margin-right: -14px;
}

.bottom-margin {
  margin-bottom: -12px;
}

.postal-address-div-margin {
  margin-bottom: -10px;
}

.postal-fields-bottom-margin {
  margin-bottom: -12px;
}

.label-margin {
  margin-top: 10px;
}

.error-div {
  height: 30px;
}

.verify-button {
  margin-top: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
